import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootPrintApiManager_ds_order_serial_tasks_by_shipmentIdService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { shipmentId?: number }): 
  Promise<{ result: { Id?: number, OrderId?: number, OrderLineNumber?: number, SerialNumberId?: number, ShipmentId?: number, ShipmentLineId?: number }[] }> 
  {
    let url = `${environment.backendUrl}api/FootPrintApiManager/datasources/ds_order_serial_tasks_by_shipmentId/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { shipmentId?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, OrderId?: number, OrderLineNumber?: number, SerialNumberId?: number, ShipmentId?: number, ShipmentLineId?: number }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/FootPrintApiManager/datasources/ds_order_serial_tasks_by_shipmentId/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { shipmentId?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, OrderId?: number, OrderLineNumber?: number, SerialNumberId?: number, ShipmentId?: number, ShipmentLineId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/FootPrintApiManager/datasources/ds_order_serial_tasks_by_shipmentId/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

